import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper, Typography, Box, Divider } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import Table from '@material-ui/core/Table'
import TablePagination from '@material-ui/core/TablePagination'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import * as _ from 'lodash'

import { GLOBAL_ATTENTION_INDEX_2 } from '../../constants/colors'
import { ATTENTION_INDEX_STREAMING_LABELS, NETWORK_LABELS } from '../../constants/labels'
import { TableFormats } from '../TableHelpers'

const BorderLinearProgressPrimary = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 1,
    backgroundColor: GLOBAL_ATTENTION_INDEX_2,
    borderColor: 'yellow'
  }
}))(LinearProgress)

export class GlobalAttentionEngagementComponent extends Component {
  static propTypes = {
    screenWidth: PropTypes.number,
    classes: PropTypes.object.isRequired,
    attentionIndexDetails: PropTypes.object,
    setSelectedPlatforms: PropTypes.func,
    selectedPlatforms: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      primaryNetworkByDistributor: null,
      page: 0,
      rowsPerPage: 3,
      networkList: null
    }
  }

  componentDidMount () {
    if (this.props.attentionIndexDetails) {
      this.setPlatformsListByEngagement()
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.attentionIndexDetails !== this.props.attentionIndexDetails) {
      this.setState({
        page: 0
      })
      this.setPlatformsListByEngagement()
    }
  }

  setPlatformsListByEngagement = () => {
    const details = this.props.attentionIndexDetails && this.props.attentionIndexDetails.details ? this.props.attentionIndexDetails.details : []
    let networkList = []
    let detail = null
    const networkLabels = NETWORK_LABELS + ',' + ATTENTION_INDEX_STREAMING_LABELS+ ',Others'
    networkLabels.split(',').map(network => {
      if (network === 'Others') {
        detail = details.filter(detail => !detail.labels || (detail.labels && ((NETWORK_LABELS + ',' + ATTENTION_INDEX_STREAMING_LABELS).split(',').flatMap(label => detail.labels.indexOf(label) < 0))))
      } else {
        detail = details.filter(detail => detail.labels && detail.labels.indexOf(network) > -1)
      }
      if (detail && detail.length > 0)
      {
        detail.map(e => {
          networkList.push({
            'network': network,
            'score': e.score ? e.score : 0
            })
        })
      } else {
        networkList.push({
          'network': network,
          'score': 0
          })
      }
    })
    let totalVolume = networkList.reduce((total, gen) => total + gen.score, 0)
    let networkListByScore = _(networkList)
    .groupBy('network')
    .map((g, network) => ({network, value: _.sumBy(g, 'score'), percentage: (_.sumBy(g, 'score') / totalVolume) * 100})).orderBy('score', 'desc')
    .value()
    networkListByScore.pop()
    networkListByScore = networkListByScore.filter(n => n.percentage >= 0.1).sort((a, b) => b.value - a.value)
    this.setState({ networkList: networkListByScore})
  }

  render () {
    const { classes, selectedPlatforms } = this. props
    const { networkList } = this.state

    const charLength = this.props.screenWidth < 375 ? 10 : this.props.screenWidth >= 375 && this.props.screenWidth < 479.95 ? 20
    : this.props.screenWidth >= 480 && this.props.screenWidth < 767.98 ? 50
    : this.props.screenWidth >= 768 && this.props.screenWidth < 1023.98 ? 40
    : this.props.screenWidth >= 1024 && this.props.screenWidth < 1199.98 ? 20
    : this.props.screenWidth >= 1200 && this.props.screenWidth < 1439.98 ? 20
    : (this.props.screenWidth >= 1440)
    ? 30 : 30

    const handleChangePage = (event, page) => {
      this.setState({page: page})
    }

    const titleWithTooltip = (title) => {
      if (title && title.length > charLength) {
        const tooltip = <Tooltip id="tooltip">{title}</Tooltip>
        return (
          <OverlayTrigger overlay={tooltip} placement='top'>
            <span className="txt">{title.substring(0, charLength)}...</span>
          </OverlayTrigger>
        )
      }
      return (<span>{title}</span>)
    }

    return (
      <Paper className={`metricBox ${classes.paper}`}>
        <Grid container spacing={1} direction="column">
          <Grid item className='cardPadding p-b-0'>
            <span className={`metricTitle ${classes.cardTitle}`}>Top platforms by engagement</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{'Top platforms by engagement'}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
        </Grid>
        { networkList &&
          networkList.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((row, index) => (
            <Box className={`${index === 0 && 'boxStart'} primary`} key={index}>
              <Box className={`${selectedPlatforms.filter(e => e === row.network).length > 0 ? 'selected-platform' : ''} d-flex align-items-center cursorPointer topEngagementFilter`} onClick={() => this.props.setSelectedPlatforms(row.network)}>
                <Box className="w-30">
                  <Typography className="metricProLabel cardTwo">{titleWithTooltip(row.network)}</Typography>
                </Box>
                <Box className="w-40 progressRotate">
                  <BorderLinearProgressPrimary variant="determinate" value={row.percentage ? row.percentage : 0} />
                </Box>
                <Box className="w-30 text-right">
                  <Typography className="metricProLabel cardTwo">{TableFormats.trackerFormatKM(row.value)} ({row.percentage && row.percentage >= 1 ? Math.round(row.percentage * 10) / 10 : row.percentage ? Math.round(row.percentage * 100) / 100 : 0}%)</Typography>
                </Box>
              </Box>
              { index !== 2 &&
                <Divider className="progressDivide"/>
              }
            </Box>
          ))
        }
        <Table className='tableFooter'>
          <TableBody>
            <TableRow>
              <TablePagination
                rowsPerPageOptions= {[3, 6, 9]}
                count={networkList ? networkList.length : 3}
                rowsPerPage={3}
                page={this.state.page}
                onChangePage={handleChangePage}
                labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}}`} results`}
              />
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default withStyles(styles)(GlobalAttentionEngagementComponent)
